
































































































































import { Vue, Component, Prop, Watch, Ref } from "vue-property-decorator";
import { groupBy as _groupBy } from "lodash";

@Component
export default class CMultiSelect extends Vue {
  @Prop() value?: any;
  @Prop() valueField?: string;
  @Prop({ default: false }) disabled?: boolean;
  @Prop() items?: Array<any>;
  @Prop() groupBy?: string;
  @Prop({ default: "title" }) label!: string;
  @Prop({ default: 200 }) debounce?: number;
  @Prop({ default: true }) isShowDisabledEntity?: boolean; // only 'enabled' field
  @Prop({ default: true }) isMarkedDisableEntity?: boolean;
  @Prop({ default: "enabled" }) fieldForCheckDisabled?: string;
  @Prop({ default: true }) isCanSelectDisabled?: boolean;
  @Prop() additionalField?: string;
  @Prop({ default: "..." }) placeholder?: string;
  @Prop() inputPlaceholder?: string;
  @Prop({ default: false }) loading?: boolean;
  @Ref("stateElement") stateElement!: HTMLDivElement;
  search: string = "";
  isShowInput: boolean = false;
  checkedItem: Array<any> = [];
  isMultiplyLineCheckedItems: boolean = false;
  widthStateField: any = this.stateElement?.offsetWidth
    ? this.stateElement?.offsetWidth - 5
    : "100%";

  showItem: boolean = true;

  outsideClick() {
    this.isShowInput = false;
  }

  get filteredAllItems() {
    let searched = this.items?.filter(el =>
      el[this.label]?.toLowerCase().includes(this.search.toLowerCase())
    );

    return !this.isShowDisabledEntity
      ? searched?.filter(el => el.enabled)
      : searched;
  }

  get groupedObject() {
    return this.groupBy ? _groupBy(this.items, this.groupBy) : undefined;
  }

  get filteredGroupedItems() {
    let searched: any = Object.assign({}, this.groupedObject);
    for (let key in searched) {
      if (searched.hasOwnProperty(key)) {
        searched[key] = searched[key].filter((el: any) =>
          el[this.label].toLowerCase().includes(this.search.toLowerCase())
        );
      }
    }
    return searched;
  }

  toggleInput() {
    this.isShowInput = !this.disabled ? !this.isShowInput : false;
    this.widthStateField = this.stateElement?.offsetWidth + "px";
  }

  reverseDisabledEntity(item: any) {
    let value: boolean = false;
    if (!this.isCanSelectDisabled) {
      value = !this.checkDisabledEntity(item);
    }
    return value;
  }

  checkDisabledEntity(item: any) {
    let check = true;
    let fieldForDisable = this.fieldForCheckDisabled
      ? this.fieldForCheckDisabled
      : undefined;

    if (
      this.isMarkedDisableEntity &&
      fieldForDisable &&
      item.hasOwnProperty(fieldForDisable)
    ) {
      check = item[fieldForDisable];
    }
    return check;
  }

  clearCheckedItems() {
    this.checkedItem = this.disabled ? this.checkedItem : [];
  }

  limitedOutput(item: any) {
    if (item.hasOwnProperty(this.label)) {
      item = item[this.label];
    }

    return item.length > 20 ? item.slice(0, 20) + "..." : item;
  }

  deleteItem(item: any) {
    this.checkedItem = this.disabled
      ? this.checkedItem
      : this.checkedItem.filter(el => el !== item);
  }

  getLabel(item: any) {
    let label;
    if (item.hasOwnProperty(this.label)) {
      const key = this.label;
      label =
        item[key]?.length > 60 ? item[key]?.slice(0, 60) + "..." : item[key];
    } else {
      return item.id;
    }
    return label;
  }

  getDeep(obj: object, myPath: string | undefined) {
    return myPath
      ? myPath.split(".").reduce((res: any, prop: string) => {
          return res[prop] ? res[prop] : "";
        }, obj)
      : undefined;
  }

  getAdditionalField(item: any) {
    let label: any;
    label = this.getDeep(item, this.additionalField);
    return label?.length > 60 ? label.slice(0, 60) + "..." : label;
  }

  getValue(item: any) {
    let value;
    if (this.valueField) {
      if (item.hasOwnProperty(this.valueField)) {
        value = item[this.valueField];
      }
    } else value = item;
    return value;
  }

  @Watch("search")
  upd() {
    this.$emit("search", this.search);
  }

  @Watch("checkedItem")
  updChecked() {
    this.$emit(
      "input",
      this.valueField
        ? this.checkedItem?.map(el => this.getValue(el))
        : this.checkedItem
    );
  }
  clearChecked() {
    if (this.value.length === 0) {
      setTimeout(() => {
        this.isShowInput = true;
        this.showItem = false;
      }, 300);

      setTimeout(() => {
        this.clearCheckedItems();
      }, 301);

      setTimeout(() => {
        this.isShowInput = false;
        this.showItem = true;
      }, 302);
    }
  }

  created() {
    this.checkedItem = this.value ? [...this.value] : [];
  }

  mounted() {
    this.clearChecked();
  }
}
